import React from 'react';
type AppProps={
    companyDetails:any;
    handleCompanyDetailsChange:(data:any)=>void;

}
const CompanyDetails = ({
    companyDetails,
    handleCompanyDetailsChange,
  

}:AppProps) => {
    return (
        <>
            <p className='ml-4' style={{marginTop:"7px", fontWeight:"500",marginBottom:"0px"}}>COMPANY DETAILS</p>
            <div className='row col-md-12' style={{marginLeft:"-4px"}}>
                <div className='col-md-3'>
                    <label className='mb-1' htmlFor='Company Name'>Company Name</label>
                    <div  >
                        <input
                            type='text'
                            name='companyName'
                            className='form-control'
                            value={companyDetails?.companyName}
                            onChange={handleCompanyDetailsChange}
                        />
                    </div>
                </div>
                <div className='col-md-3'>
                    <label className='mb-1' htmlFor='Contact Person Name'>Contact Person Name</label>
                    <div  >
                        <input
                            type='text'
                            name='contactPersonName'
                            className='form-control'
                            value={companyDetails?.contactPersonName}
                            onChange={handleCompanyDetailsChange}
                        />
                    </div>
                </div>
                <div className='col-md-3'>
                    <label className='mb-1' htmlFor='Contact Number'>Contact Number</label>
                    <div  >
                        <input
                            type='number'
                            name='contactNumber'
                            className='form-control'
                            value={companyDetails?.contactNumber}
                            onChange={handleCompanyDetailsChange}
                        />
                    </div>
                </div>
                <div className='col-md-3'>
                    <label className='mb-1' htmlFor='Email ID'>Email ID</label>
                    <div  >
                        <input
                            type='text'
                            name='emailId'
                            className='form-control'
                            value={companyDetails?.emailId}
                            onChange={handleCompanyDetailsChange}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default CompanyDetails